const ApiUrl = {
    SGKDomain: "/api/sgk",
    EbasvurCoreDomain: "/pma/core",
    IKDomain: "/api/ik",
    AksiyonDomain: "/api/aksiyon",
    SablonDomain: "/api/sablondomain",
    IKTestMerkeziDomain: "/api/iktestmerkezidomain",
    IKIseAlimDomain: "/api/ikisealim",
    MasterDomain: "/api/master",
    AxDomain: "/api/ax",
    PMADomain: "/api/pma/ebasvuru",
    PublicDomain: "/api/public",
    AdayDomain: "/api/adayDomain",
    MailTemplateDomain: "/api/mailtemplatedomain",
    SmartDomain: "/api/smart",
    controller: {
        SGKIsKazasiBildirimleri: "/sgkiskazasibildirimleri",
        SGKABPYRSubeler: "/sgkabpyrsubeler",
        SGKBolgeler: "/sgkbolgeler",
        SGKIsKazalariWS: "/sgkiskazalariws",
        SGKEViziteWS: "/sgkevizitews",
        SGKEViziteOnayliWS: "/sgkeviziteonayliws",
        SGKEViziteOnayliDetayWS: "/sgkeviziteonaylidetayws",
        SGKTescilGirisCikisIsEmir: "/sgktescilgiriscikisisemir",
        SGKEBorcuYokturKayitlari: "/sgkeborcuyokturkayitlari",
        SGKTahakkukFisleri: "/sgktahakkukfisleri",
        SGKHizmetListesi: "/sgkhizmetlistesi",
        SGKMufredatKarti: "/sgkmufredatkarti",
        SGKEmanet: "/sgkemanet",
        SGKAsgariUcretDestegi: "/sgkasgariucretdestegi",
        Sablonlar: "/sablonlar",
        Tipleri: "/tipleri",
        Parametre: "/parametre",
        SGKGirisCikislar: "/sgkgiriscikislar",
        SGKABPYRSGKHizmetList: "/sgkabpyrsgkhizmetlist",
        SGKGirisCikisKontrol: "/sgkgiriscikiskontrol",
        SGKABPYRSGKTesvikAdaylariFaydalanma: "/sgkabpyrsgktesvikadaylarifaydalanma",
        SGKTesvikAdaylari: "/sgktesvikadaylari",
        SGKTesvikMonitor: "/sgktesvikmonitor",
        SGKPotansiyelTesvikSorgulama: "/sgkpotansiyeltesviksorgulama",
        SGKBatchParameter: "/sgkbatchparameter",
        SGKDashboard: "/sgkdashboard",
        SGKTesvikDurumlari: "/sgktesvikdurumlari",
        sgkeviziterapordurumlari: "/sgkeviziterapordurumlari",
        MasterUser: "/masteruser",
        sgkMusteri: "/sgkmusteri",
        sgkIsKazalariWSLog: "/sgkiskazalariwslog",
        sgkAUDDonemPersonelSayisi: "/sgkauddonempersonelsayisi",
        sgkAUDIsyeriGunSayilari: "/sgkaudisyerigunsayilari",
        sgkAUDTesviklerPage: "/sgkaudtesvikler",
        sgkIsKazasiMonitorWSLog: "/sgkiskazasimonitorwslog",
        sgkIsKazasiMonitorWS: "/sgkiskazasimonitorws",
        sgkABPYRKodlar: "/sgkabpyrkodlar",
        sgkIsKazasiBatchMonitor: "/sgkiskazasibatchmonitor",
        sgkIsKazasiMonitor: "/sgkiskazasimonitor",
        sgkEViziteMonitorWS: "/sgkevizitemonitorws",
        sgkEViziteOnayliMonitorWS: "/sgkeviziteonaylimonitorws",
        sgkEViziteOnayLog: "/sgkeviziteonaylog",
        sgkViziteMailAlicilari: "/sgkvizitemailalicilari",
        sgkSirketler: "/sgksirketler",
        sgkEBorcBatchMonitor: "/sgkeborcbatchmonitor",
        sgkEBorcuYokturMonitor: "/sgkeborcuyokturmonitor",
        sgkEViziteMahsupMonitor: "/sgkevizitemahsupmonitor",
        sgkPeriods: "/sgkperiods",
        sgkCalismaTakvimi: "/sgkcalismatakvimi",
        sgkEViziteMahsup: "/sgkevizitemahsup",
        sgkEviziteMahsupLog: "/sgkevizitemahsuplog",
        sgkIntegration: "/sgkintegration",
        sgkSubeler: "/sgksubeler",
        SoruSeti: "/soruseti",
        SoruSetiKriterleri: "/sorusetikriterleri",
        SoruSetiKriterKabulSecenekleri: "/sorusetikriterkabulsecenekleri",
        AdayCevaplar: "/adaycevaplar",
        AksiyonLog: "/aksiyonlog",
        Aday: "/aday",
        AdayTest: "/adaytest",
        AdayTestYanitlar: "/adaytestyanitlar",
        TestTip: "/testtip",
        TestSonuc: "/testsonuc",
        Faktor: "/faktor",
        Tedarikci: "/tedarikci",
        FaktorSkorAralik: "/faktorskoraralik",
        Sorular: "/sorular",
        SoruYanitlar: "/soruyanitlar",
        ARSAdaylar: "/arsadaylar",
        ARSProjesi: "/arsprojesi",
        IKSubeler: "/iksubeler",
        IKAdayKategorileri: "/adaykategorileri",
        IKKategoriler: "/ikkategoriler",
        kullanicilari: "/kullanicilari",
        sgkSysRol: "/sysrol",
        Kritertanimlari: "/kritertanimlari",
        MasterTenant: "/mastertenant",
        MasterUserTenant: "/masterusertenant",
        MasterTenantModul: "/mastertenantmodul",
        MasterTenantUserModul: "/mastertenantusermodul",
        KullaniciRolleri: "/kullanicirolleri",
        AxIntegration: "/axintegration",
        MenulerIcon: "/menulericon",
        MenulerYol: "/menuleryol",
        Menuler: "/menuler",
        RollerYetki: "/rolleryetki",
        Sehir: "/sehir",
        BatchOperation: "/batchoperation",
        HangfireLoglama: "/hangfireloglama",
        TenantBatchOperation: "/tenantbatchoperation",
        WorkerPlannedJob: "/workerplannedjob",
        SGKWorkerTask: "/sgkworkertask",
        SGKWorkerMonitor: "/sgkworkermonitor",
        SGKWorkerMonitorSummary: "/sgkworkermonitorsummary",
        MailGrupViziteAlici: "/mailgrupvizitealici",
        SGKWorker: "/sgkworker",
        MailGruplari: "/mailgruplari",
        SysGlobalKeyValue: "/sysglobalkeyvalue",
        SysGlobalKey: "/sysglobalkey",
        SharedMemoery: "/sharedmemoery",
        Module: "/module",
        TescilWSLog: "/tescilwslog",
        AdayIdxRoot: "/adayidxroot",
        SysGlobalGroup: "/sysglobalgroup",
        SGKParameter: "/sgkparameter",
        KriterSecenekleri: "/kritersecenekleri",
        SGKMasterParameter: "/sgkmasterparameter",
        Basvurular: "/basvurular",
        TokenKodlari: "/tokenkodlari",
        KriterGrubuDetay: "/kritergrubudetay",
        Projesi: "/Projesi",
        BasvuruFormuBlok: "/basvuruformublok",
        EbasvuruTenant: "/ebasvurutenant",
        KriterModul: "/kritermodul",
        BasvuruFormuModul: "/basvuruformumodul",
        KriterTanimlari: "/kritertanimlari",
        KriterModulBilesen: "/kritermodulbilesen",
        eBasvuruGirisCikislar: "/ebasvurugiriscikislar",
        kriterkategori: "/kriterkategori",
        sgkKodlari: "/sgkkodlari",
        sgkKodTipleri: "/sgkkodtipleri",
        KriteraltKategori: "/kriteraltkategori",
        KriterSecenekSablonu: "/kriterseceneksablonu",
        KriterSecenekSablonuSecenekleri: "/kriterseceneksablonusecenekleri",
        KriterKomponentBilesen: "/kriterkomponentbilesen",
        KriterKomponent: "/kriterkomponent",
        KriterGrubu: "/kritergrubu",
        BasvuruFormu: "/basvuruformu",
        AdayIdxIzinler: "/adayidxizinler",
        EnumValues: "/enumvalues",
        IdxGoruntulemeLog: "/idxgoruntulemelog",
        DegerRotaBasvuruAdim: "/degerrotabasvuruadim",
        DegerRotaBasvuru: "/degerrotabasvuru",
        AdayNotlari: "/adaynotlari",
        MailTemplate: "/mailtemplate",
        BasvuruNotlari: "/basvurunotlari",
        RecievedSMS: "/recievedsms",
    },
    endpoint: {
        Get: "/get",
        fullGet: "/fullGet",
        GetList: "/getList",
        Pagination: "/pagination",
        Create: "/create",
        Update: "/update",
        UpdateDynamic: "/dynamic_update",
        Delete: "/delete",
        Register: "/register",
        KullaniciPagination: "/custompagination",
        Remove: "/remove",
        bulkReset: "/bulkreset",
        reset: "/reset",
        moveup: "/moveup",
        movedown: "/movedown",
        manualkapatma: "/manualkapatma",
        iptal: "/iptal",
        reuploaddocument: "/reuploaddocument",
        bulkSet: "/bulkset",
        bulkResetJobOrWorker: "/bulkResetJobOrWorker",
        bulkSetJobOrWorker: "/bulkSetJobOrWorker",
        getpersonelinfo: "/pma/ebasvuru/recruiter/getpersonelinfo",
        getpersonelList: "/pma/ebasvuru/recruiter/recruiterlistewithroller",
        smsparametreList: "/pma/ebasvuru/smsparametre/getsmsparametresmstipiid",
        getMaxSira: "/getMaxSira",
        getKullaniciYetkisi: "/getKullaniciYetkisi",
        uploadExcel: "/uploadExcel",
        LogOperation: "/log_operation",
        ResetOperation: "/reset_operation",
        getMonitorJobSummary: "/getMonitorJobSummary",
        GetTenantMailGroup: "/getTenantMailGroup",
        LoginAutomation: "/LoginAutomation",
        GetGlobal: "/GetGlobal",
        registerKey: "/registerKey",
        SyncGlobalUpdate: "/SyncGlobalUpdate",
        getikametmahalle: "/get_ikamet_mahalle",
        TriggerOperation: "/trigger_operation",
        CreateWithKriterList: "/createwithkriterlist",
        UpdateWithKriterList: "/updatewithkriterlist",
        GetDynamicList: "/getdynamiclist",
        getSMSToken: "/getToken",
        GetBasvuruDurum: "/getBasvuruDurum",
        getAdayBasvurForm: "/getAdayBasvurForm",
        deleteKomponentKriter: "/deleteKomponentKriter",
        kriterZorunlu: "/kriterZorunlu",
        KomponentkriterZorunlu: "/komponentkriterzorunlu",
        KriterList: "/kriterList",
        AdayCard: "/adaycard",
        BasvuruAdayOlumSuz: "/setBasvuruAdayOlumSuz",
        Basvuru_BasvuruKopyala: "/pma/ebasvuru/Basvuru/BasvuruKopyala",
        getBasvuruCVPDF: "/getBasvuruCVPDF",
        getBasvuruPmaCVPDF: "/getBasvuruPmaCVPDF",
        CreateArsforKampanya: "/createarsforkampanya",
        ByActionAndType: "/ByActionAndType",
        DocUploadMailEkiYukle: "/pma/core/DocUpload/MailEkiYukle",
        CreateBulk: "/createbulk",
    },
    publicEndpoint: {
        Projesi: "/projesi",
        Ilceler: "/ilceler",
        Sehir: "/sehir",
        Isler: "/isler",
        AdayIdxRoot: "/adayidxroot",
        AdyRegister: "/adyRegister",
        SendSMS: "/pma/ebasvuru/public/iletisim/Start",
        OnayKoduGiris: "/pma/core/kullanici/token/OnayKoduGirisi",
        FotoYukle: "/api/adayDomain/adayidxroot/uploadeImage",
        UploadCv: "/api/adayDomain/adayidxroot/uploadcv",
    },
    widgets: {
        Calismadonemi: "/calismadonemi",
        Tesvikkazanciniz: "/tesvikkazanciniz",
        hataalantescilislemleri: "/hataalantescilislemleri",
        eviziteonaybekleyenler: "/eviziteonaybekleyenler",
        IskursuzSayisi: "/iskursuzSayisi",
        GetAktifAdaySayisi: "/getAktifAdaySayisi",
        GetToplamBildirilenPersonelSayisi: "/getToplamBildirilenPersonelSayisi",
        ToplamPEK: "/toplamPEK",
        YeniAdaySayisi: "/YeniAdaySayisi",
        personelsayisi: "/personelsayisi",
        bildirimyapilmamisiskazasi: "/bildirimyapilmamisiskazasi",
        GirisCikisKontrolhatasi: "/GirisCikisKontrolhatasi",
        getEBorcuYokturKayitlari: "/getEBorcuYokturKayitlari",
        ensonborcsorgutarihi: "/ensonborcsorgutarihi",
        eborctoplami: "/eborctoplami",
        borcuolansirketsayisi: "/borcuolansirketsayisi",
        viziteMahsup: "/viziteMahsup",
        borcuolanisyerisayisi: "/borcuolanisyerisayisi"
    },
    integration: {
        HasIsKazaSorguTarihle: "/hasIsKazaSorguTarihle",
        GetPersonalByNo: "/GetPersonalByNo",
        GetPersonalByTC: "/GetPersonalByTC",
    },
    reports: {
        personelSayisi: "/personelSayisi",
        nedenlerineGoreCikislar: "/nedenlerineGoreCikislar",
        donemlereGoreCikislar: "/donemlereGoreCikislar",
        nedenlerineGoreEksikGunler: "/nedenlerineGoreEksikGunler",
        bildirimyapilmamisiskazasi: "/bildirimyapilmamisiskazasi",
        ensonborcsorgutarihi: "/ensonborcsorgutarihi",
        donemlereGoreEksikGunler: "/donemlereGoreEksikGunler",
        donemlereGoreIsKazalari: "/donemlereGoreIsKazalari",
        bolgelereGoreIsKazalari: "/bolgelereGoreIsKazalari",
        donemlereGoreRaporlar: "/donemlereGoreRaporlar",
        bolgelereGoreRaporlar: "/bolgelereGoreRaporlar",
        donemlereGorePEK: "/donemlereGorePEK"
    },
    auth: {
        authenticate: "/authenticate",
        refreshtoken4master: "/refreshtoken_master",
        listAuthorizedTenants: "/listAuthorizedTenants",
        authenticate4TenantToken: "/authenticate4TenantToken",
        expireRefreshToken: "/expireRefreshToken",
        getTenantByToken: "/getTenantByToken",
        getPublicTenantByToken: "/pma/ebasvuru/public/getTenantByToken",
        createUITenantToken: "/createUITenantToken",
        getbyToken: "/pma/ebasvuru/kullanici/getbyToken"

    }

};

export default ApiUrl;